import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";

export type HapticStyle = 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' | 'selection';

// Default haptic styles for different button types
export const DEFAULT_BUTTON_HAPTIC: HapticStyle = 'light';
export const DEFAULT_GRADIENT_BUTTON_HAPTIC: HapticStyle = 'medium';

export const triggerHaptic = async (style: ImpactStyle = ImpactStyle.Medium) => {
  if (Capacitor.isNativePlatform()) {
    await Haptics.impact({ style });
  }
};

export const triggerNotification = async (type: NotificationType = NotificationType.Success) => {
  if (Capacitor.isNativePlatform()) {
    await Haptics.notification({ type });
  }
};
